var React = require('react');

function HideRecurrences (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"hideRecurrences"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"hideRecurrences","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},[React.createElement("polygon",{"id":"Fill-1","fill":"#000000","points":"2 2 2 4.001 2 8 4 8 4 4.001 12 4.001 12 2","key":0}),React.createElement("polygon",{"id":"Fill-2","fill":"#000000","points":"15 5.0005 7 5.0005 5 5.0005 5 7.0005 5 11.0005 7 11.0005 7 7.0005 13.671 7.0005 15 5.6715","key":1}),React.createElement("polygon",{"id":"Fill-3","fill":"#000000","points":"8 8.0005 8 12.6715 12.671 8.0005","key":2}),React.createElement("polygon",{"id":"Fill-4","fill":"#000000","points":"18 14.0005 18 8.3295 12.329 14.0005","key":3}),React.createElement("polygon",{"id":"Fill-5","fill":"#000000","points":"6.0428 16.0436 7.4568 17.4576 20.4568 4.4566 19.0428 3.0436","key":4})])]);
}

HideRecurrences.defaultProps = {"width":"21px","height":"18px","viewBox":"0 0 21 18","version":"1.1"};

module.exports = HideRecurrences;

HideRecurrences.default = HideRecurrences;



// WEBPACK FOOTER //
// ./src/icons/hideRecurrences.svg